export default __webpack_public_path__ + "static/media/slide1.e098a155.jpg";